// ============================================
// Khiếu nại hoá đơn sau bán — sheet 2 mục #58/#60
// ============================================
//
// Contract: disputes.service.ts
//   GET  /disputes/                    hàng đợi (chỉ store-admin)
//   POST /disputes/{id}/resolve/       chốt TỪNG DÒNG
//
// Điểm phải nhớ khi sửa màn này:
// - Máy KHÔNG BAO GIỜ tự từ chối. Mọi ca REJECTED đều do người bấm ở đây, nên
//   `note` là thứ DUY NHẤT khách đọc được để hiểu vì sao (BE trả lại dưới tên
//   `resolution_note`). UI bắt buộc nhập note khi có dòng bị từ chối.
// - Chốt ở đây là HOÀN TIỀN THẬT (có dòng trên sao kê khách), không phải nhả
//   khoản giữ tạm — không đảo ngược được bằng cách bấm lại.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import type { Dispute, UUID } from '@conai/shared-types';
import type { DisputeListParams, ResolveDisputeRequest } from '@conai/api-client';
import { useDisputesService } from '../providers/ApiProvider';
import { queryKeys } from '../config/query-client';

export function useDisputes(filters: DisputeListParams = {}) {
  const disputesService = useDisputesService();

  return useQuery({
    queryKey: queryKeys.disputes.list(filters as Record<string, unknown>),
    queryFn: () => disputesService.list(filters),
  });
}

export function useResolveDispute() {
  const disputesService = useDisputesService();
  const queryClient = useQueryClient();

  return useMutation<Dispute, unknown, { disputeId: UUID; data: ResolveDisputeRequest }>({
    mutationFn: ({ disputeId, data }) => disputesService.resolve(disputeId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.disputes.all });
      toast.success('Đã chốt khiếu nại');
    },
  });
}
